// @module NVT.MyOrganiserProfile.MyOrgProfile
define('NVT.MyOrganiserProfile.MyOrgProfile.View'
,	[
	'nvt_myorganiserprofile_myorgprofile.tpl'

	,	'NVT.MyOrganiserProfile.MyOrgProfile.SS2Model'

	,	'Backbone'

	, 'NVT.MyOrganiserProfile.MyOrgProfile.View'

	, 'ProductDetails.Full.View'
    ]
, function (
	nvt_myorganiserprofile_myorgprofile_tpl

	,	MyOrgProfileSS2Model

	,	Backbone

	, MyOrgProfileView

	, ProductDetailsFullView
)
{
    'use strict';

	// @class NVT.MyOrganiserProfile.MyOrgProfile.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_myorganiserprofile_myorgprofile_tpl

	,	initialize: function (options) {
		this.options = options;
		this.container = options.container;
		this.layout = this.container.getComponent('Layout');
		this.pdp = this.container.getComponent('PDP');
		var self = this;
		if (self.pdp) {
			self.pdp.on("afterShowContent", function () {
				var itemDetailMyorg = self.pdp.getItemInfo();
					var model = new MyOrgProfileSS2Model();
					model
						.fetch({
						async: false,
						data: {
							getsku: itemDetailMyorg.item.itemid,
							mopimg: SC.CONFIGURATION.MyOrgProfile.config
						},
						})
						.done(function (result) {
						self.listorganiserprofileinfo = result.message
						self.render();
						});
				});
			}
	}
	,	events: {
		'click [data-action="data-action-speaker-information-details"]': 'organiserprofileinfo'
		}

	,	bindings: {
		}

	, 	childViews: {

		}

	,	  organiserprofileinfo : function(e){
					var self = this;
					var getcurrentvalue_1 = e.currentTarget.value
					if(getcurrentvalue_1){
						var getlistselect = self.listorganiserprofileinfo.filter(function(spdata) {
							return spdata.id == getcurrentvalue_1
						});
						if (this.layout && getlistselect.length > 0) {

							var modalMessage = new MyOrgProfileView({
								container: this.container,headertitle:getlistselect[0].name, itemcode:getlistselect[0].itemcode ,itemimage:getlistselect[0].imagess ,getspeakersinformation: getlistselect[0].orgprofile,orgwebaddress: getlistselect[0].orgwebaddress
							});
								modalMessage.modalClass ='modal-md';
								modalMessage.title= getlistselect[0].name || '',
								this.options.container.layout.showInModal(modalMessage);
							return false;
						}
				}
	  }

		//@method getContext @return NVT.MyOrganiserProfile.MyOrgProfile.View.Context
	,	getContext: function getContext()
		{
			//@class NVT.MyOrganiserProfile.MyOrgProfile.View.Context
			//this.message = this.message
			return {
				imagess: this.options.imagess ?  this.options.imagess : SC.CONFIGURATION.MyOrgProfile.config ,
				listorganiserprofileinfo: this.listorganiserprofileinfo || '',
				headertitle :  this.options.headertitle || '' ,
				itemcode :  this.options.itemcode || '' ,
				itemimage : this.options.itemimage ? this.options.itemimage :  SC.CONFIGURATION.MyOrgProfile.config ,
				externallinkurlss : this.options.orgwebaddress || '' ,
				getspeakersinformation :  this.options.getspeakersinformation || '' ,
			};
		}
	});
});
